module.exports = __webpack_public_path__ + "img/28.5c625634.png";